import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/Auth0Context.jsx';

export default function AdminRoute({ allowDevBypass = false, children }) {
  const { loading, user } = useAuth();

  if (loading) return null;
  if (import.meta.env.DEV && allowDevBypass) return children;
  if (!user?.is_admin) return <Navigate to="/" replace />;

  return children;
}
